<ihd-icon [name]="icon" class="x-icon-btn__icon" [ngClass]="iconClasses" *ngIf="icon"></ihd-icon>
<ng-content></ng-content>
